export const servicesData = [
  {
    num: '01',
    iconKey: 'android',
    title: 'Native Android',
    subtitle: 'Kotlin & Jetpack Compose',
    items: [
      'Kotlin & Jetpack Compose UI',
      'Clean Architecture + MVVM',
      'Room Database integration',
      'AI API integrations',
      'Offline-first architecture',
    ],
  },
  {
    num: '02',
    iconKey: 'flutter',
    title: 'Flutter Apps',
    subtitle: 'Cross-Platform iOS & Android',
    items: [
      'Cross-platform iOS & Android',
      'BLoC state management',
      'Firebase real-time backend',
      'Geo-fencing & location features',
      'Custom animations & UI',
    ],
  },
  {
    num: '03',
    iconKey: 'ai',
    title: 'AI Integration',
    subtitle: 'Smart Features That Ship',
    items: [
      'Food recognition via AI APIs',
      'Automated feature pipelines',
      'Smart data extraction',
      'API orchestration & caching',
      'Real business value, not hype',
    ],
  },
  {
    num: '04',
    iconKey: 'database',
    title: 'Backend & Database',
    subtitle: 'Firebase, PostgreSQL, Room',
    items: [
      'Firebase Auth & Firestore',
      'PostgreSQL database design',
      'Room local database',
      'Real-time data sync',
      'Secure data architecture',
    ],
  },
];
